angular.module('Itao.IndicatorMap').factory('ScaleService', function () {
  'use strict';

  /**
   * Scale constructor
   * @param from
   * @param to
   * @param color
   * @param name
   * @constructor
   */
  function Scale(from, to, color, name) {
    this.from = parseFloat(from);
    this.to = parseFloat(to);
    this.color = color;
    this.name = name;
  }

  Scale.prototype.isValueInsideScale = function (value) {
    return value >= this.from && value <= this.to;
  };

  return {
    createScale: function (from, to, color, name) {
      return new Scale(from, to, color, name);
    }
  };
});
